import CardWrapper from '../../components/wrapper/card';
import ChooseServiceProviderModal from '../../components/integrations/modal/choose_service_provider';
import CreateTwilioIntegration from '../../components/integrations/modal/twilio_integration';
import { fetchClientIntegrationsThunk } from '../../redux/thunks/integration';
import { green } from '../../theme/themePrimitives';
import ImageClass from '../../assets';
import { IntegrationObjectForRender } from '../../params/redux/integration';
import RemoveIntegrationModal from '../../components/integrations/modal/remove_Integration';
import RemoveTwilioAccountModal from '../../components/integrations/modal/remove_twilio_account';
import { useParams } from 'react-router';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

const ClientIntegrationPage = () => {
    const { id } = useParams();
    const dispatch = useDispatch<AppDispatch>();
    const [chooseServiceProvider, setChooseServiceProvider] = useState<boolean>(false);
    const [isRemoving, setIsRemoving] = useState<boolean>(false);
    const [showTwilio, setShowTwilio] = useState<boolean>(false);
    const [isRemovingTwilio, setIsRemovingTwilio] = useState<boolean>(false);
    const [selectedProvider, setSelectedProvider] = useState<'calendar' | 'email' | 'meet' | 'twilio' | 'stripe' | ''>('');
    const { integrations } = useSelector((state: RootState) => state.integration);
    const { currentUser } = useSelector((state: RootState) => state.app);

    const onSubmitHandler = (type: 'calendar' | 'email' | 'meet' | 'twilio' | 'stripe') => {
        try {
            const existingIntegration = integrations.includes(type);
            if (type === 'twilio') {
                if (existingIntegration) {
                    setIsRemovingTwilio(true);
                    return;
                }
                setShowTwilio(true);
            } else {
                setSelectedProvider(type);
                if (!existingIntegration) {
                    setChooseServiceProvider(true);
                    return;
                }
                setIsRemoving(true);
            }
        } catch (e) {
            console.error('Error handling integration:', e);
        }
    };

    const integration: IntegrationObjectForRender[] = [
        {
            id: 1,
            title: 'Email Integration',
            type: 'email',
            description: 'Spend less time combing through contacts with different email service provider.',
            icon: <img src={ImageClass.emailIntegration} alt="email ingtegration" width={60} height={50} />,
            onClick: () => onSubmitHandler('email'),
            roles: ['organizationAdmin', 'organizationOwner', 'companyManager', 'salesManager', 'salesMember', 'client', 'user']
        },
        {
            id: 2,
            title: 'Twilio Integration',
            type: 'twilio',
            description: 'Communicate Quickly & Reliably with Twilio.',
            icon: <img src={ImageClass.twilioLogo} alt="Twilio Logo" width={60} height={60} />,
            onClick: () => onSubmitHandler('twilio'),
            roles: ['organizationOwner', 'client', 'user']
        },
        {
            id: 3,
            title: 'Calendar Integration',
            type: 'calendar',
            description: 'Stay organized by keeping all reminders and meetings in one centralized calendar.',
            icon: <img src={ImageClass.calendar} alt="Calendar" width={60} height={60} />,
            onClick: () => onSubmitHandler('calendar'),
            roles: ['organizationAdmin', 'organizationOwner', 'companyManager', 'salesManager', 'salesMember', 'client', 'user']
        },
        {
            id: 4,
            title: 'Google Meet',
            type: 'meet',
            description: 'This connection will be able to generate Google Meeting video conference links.',
            icon: <img src={ImageClass.googleCalendarLogo} alt="Google Calendar Logo" width={60} height={60} />,
            onClick: () => onSubmitHandler('meet'),
            roles: ['organizationAdmin', 'organizationOwner', 'companyManager', 'salesManager', 'salesMember', 'client', 'user']
        }
    ];

    useEffect(() => {
        const fetchIntegrations = async () => {
            try {
                await dispatch(fetchClientIntegrationsThunk(parseInt(id as string, 10))).unwrap();
            } catch (e) {
                //
            }
        };
        fetchIntegrations();
    }, []);

    return (
        <Box p={2} minHeight="80vh" overflow="auto">
            <CardWrapper>
                <Box display="flex" justifyContent="center" alignItems="center" gap={2} flexWrap="wrap">
                    {integration.map((integ, index) => {
                        const isIntegrated = integrations.includes(integ.type);
                        return (
                            <Box key={index} minWidth={currentUser?.role === 'client' ? '49%' : (index >= 3 ? '49%' : '32.4%')} maxWidth={currentUser?.role === 'client' ? '49%' : (index >= 3 ? '49%' : '32.4%')}>
                                <CardWrapper>
                                    <Box minHeight="195px" display="flex" flexDirection="column" justifyContent="center">
                                        <Box display="flex" justifyContent="space-between" alignItems="center">
                                            <Box>{integ.icon}</Box>
                                            <Button
                                                variant="outlined"
                                                color={isIntegrated ? 'error' : 'primary'}
                                                onClick={integ.onClick}
                                            >
                                                {isIntegrated ? 'Remove' : 'Connect'}
                                            </Button>
                                        </Box>
                                        <Box display="flex" gap={2} alignItems="center">
                                            <Typography my={1} variant="h5" color="textSecondary">
                                                {integ.title}
                                            </Typography>
                                            {isIntegrated && <Box
                                                px={2}
                                                borderRadius={1}
                                                width="max-content"
                                                py="0.1rem"
                                                bgcolor={green[100]}
                                                color={green[400]}
                                                height="max-content"
                                            >
                                                <Typography variant="body1" fontWeight="500">Connected</Typography>
                                            </Box>}
                                        </Box>
                                        <Typography variant="subtitle1" color="textDisabled">{integ.description}</Typography>
                                    </Box>
                                </CardWrapper>
                            </Box>
                        );
                    })}
                </Box>
            </CardWrapper>
            {isRemoving && <RemoveIntegrationModal open={isRemoving} onClose={() => setIsRemoving(false)} type={selectedProvider as 'meet' | 'calendar' | 'email' | 'twilio' | 'stripe'} />}
            {chooseServiceProvider &&
                <ChooseServiceProviderModal open={chooseServiceProvider} onClose={() => setChooseServiceProvider(false)} selectedProvider={selectedProvider} />}
            {showTwilio && <CreateTwilioIntegration open={showTwilio} onClose={() => setShowTwilio(false)} />}
            {isRemovingTwilio && <RemoveTwilioAccountModal open={isRemovingTwilio} onClose={() => setIsRemovingTwilio(false)} />}
        </Box>
    );
};

export default ClientIntegrationPage;
